var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"mb-1"},[_c('b-col',{staticClass:"text-right pr-1",attrs:{"sm":"12","md":_vm.md,"lg":_vm.lg,"xl":_vm.xl}},[_vm._v(_vm._s(_vm.titulo))]),_c('b-col',{staticClass:"pl-1",attrs:{"sm":"12","md":_vm.mddiff,"lg":_vm.lgdiff,"xl":_vm.xldiff}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }